var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-header"},[_c('div',{staticClass:"table-header-content"},[_vm._l((_vm.fields),function(item){return [_c('div',{key:item.label,staticClass:"table-header-titles",class:'table-header-titles--' + item.label,style:(_vm.styles)},[_vm._v(" "+_vm._s(_vm.$t("accountTable." + item.label))+" ")])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }